require('jQuery.serializeObject');
const debounce = require('lodash.debounce');

export default ($container) => {
    // Retention check form handling
    $('.js-retention-check-business', $container).on('change', function() {
        const business     = $(this).val();
        const $tab         = $(`#business-${business}[role="tabpanel"]`);
        const $allTabs     = $tab.closest('.tab-content').find('[role="tabpanel"]');
        const $previousTab = $allTabs.filter('.active[role="tabpanel"]');

        // Sync control values to other business forms
        $(':input', $previousTab).each(function() {
            const $input = $(this);
            const name   = $input.attr('name');
            if (name.indexOf('[') === -1) {
                return;
            }
            const nameWithoutBusiness = name.substr(name.indexOf('['));
            const value               = $input.val();
            $allTabs.each(function() {
                if ($input.is(':checkbox, :radio')) {
                    $(`:input[name$="${nameWithoutBusiness}"][value="${value}"]`, this).prop('checked', $input.is(':checked'));
                } else {
                    $(`:input[name$="${nameWithoutBusiness}"]`, this).val(value);
                }
            });
        });

        // Change active tab (disable inputs in non-active tabs)
        $allTabs.removeClass('active').trigger('hide.bs.tab');
        $(':input', $allTabs).prop('disabled', true);
        $tab.tab('show');
        $(':input', $tab).prop('disabled', false);
    });

    // AJAX form submission replacing itself
    $.containerOrSelf('form.js-submit-ajax', $container).on('submit', function(e) {
        e.preventDefault();
        const $form = $(this);
        $form.addClass('loading').find(':input').blur();
        const data   = $form.serializeObject();
        const action = $form.attr('action');

        $.ajax({
            url:     $form.attr('action'),
            method:  $form.attr('method'),
            data:    data,
            headers: {
                'App-XHR-Form': '?1',
            }
        }).done((data, statusText, xhr) => {
            // Redirected to another page, load it
            const newLocation = xhr.getResponseHeader('App-Window-Location');
            if (typeof newLocation === 'string' && newLocation.length > 0) {
                window.location = newLocation;
                return;
            }
            const $content = $(data);
            const $newForm = $(`form[action="${action}"]`, $content);
            $form.replaceWith($newForm);
            window.app.loadComponentsFor($newForm);
            $newForm.trigger('ajax-loaded.app.form');
        }).fail((xhr) => {
            $form.removeClass('loading');
            if (xhr.statusText === 'abort') {
                return;
            }
            alert('Er ging iets mis met het versturen. Herlaad de pagina en probeer het opnieuw.');
        });
    });

    // Auto submission of forms on entered input
    $('.js-auto-submit :input:visible', $container).on('input', debounce(function(e) {
        $(this).closest('form.js-auto-submit').trigger('submit');
    }, 500));

    if ($container.is('body')) {
        // Trigger initial change
        $('.js-retention-check-business', $container).trigger('change');

        // Enable all inputs on submission
        $('.js-retention-check-business', $container).closest('form').on('submit', function() {
            $('[role="tabpanel"] :input', this).prop('disabled', false);
        });
    }
}
